import { render } from "./DistributorForm.vue?vue&type=template&id=152f51de"
import script from "./DistributorForm.vue?vue&type=script&lang=js"
export * from "./DistributorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__